import { motion } from 'framer-motion';
import { ENGAGEMENTS, CALENDAR_2026 } from './data';

// ENGAGEMENTS — three booking modes + 2026 calendar strip.
export default function Engagements({ setPage }) {
  return (
    <div className="bg-[#F4EEE0] text-[#1A1410] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#1A1410]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#7B1A1A] mb-3">— § III / Engagements · three modes & the 2026 calendar</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">Three ways<br />we work together.</h1>
      </section>

      {/* THREE MODES — newspaper section cards, each with full pricing */}
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14 grid md:grid-cols-3 gap-px bg-[#1A1410]/15">
        {ENGAGEMENTS.map((eng, i) => (
          <motion.article key={eng.mode} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.07 }} className="bg-[#F4EEE0] p-8 lg:p-10 flex flex-col">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#7B1A1A] border-b-2 border-[#7B1A1A] pb-2 mb-5">Mode {String.fromCharCode(65 + i)}</p>
            <h3 className="font-serif italic text-3xl lg:text-4xl leading-[1.05]" dangerouslySetInnerHTML={{ __html: eng.mode }} />
            <p className="font-serif text-sm text-[#1A1410]/65 leading-[1.7] mt-3" dangerouslySetInnerHTML={{ __html: eng.cad }} />
            <div className="mt-7 space-y-3 flex-1 font-mono text-[11px] tracking-[0.18em] uppercase">
              <Row k="For" v={eng.for} />
              <Row k="Investment" v={eng.from} bold />
              <Row k="Availability" v={eng.avail} />
              <Row k="2026 status" v={eng.cur} />
            </div>
            <button onClick={() => setPage('apply')} className="mt-7 w-full font-mono text-[10px] tracking-[0.32em] uppercase bg-[#1A1410] text-[#F4EEE0] py-3 hover:bg-[#7B1A1A] transition-colors" data-testid={`mv-mode-${i}`}>Write to apply →</button>
          </motion.article>
        ))}
      </section>

      {/* 2026 CALENDAR — newspaper schedule strip */}
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-10">
        <div className="border-y-[3px] border-[#1A1410] py-3 flex items-baseline justify-between mb-7 font-mono text-[10px] tracking-[0.32em] uppercase text-[#1A1410]/65">
          <span>The 2026 Calendar</span>
          <span>Updated weekly · Tickets are not for resale</span>
        </div>
        <div className="divide-y divide-[#1A1410]/15 border border-[#1A1410]/15 bg-white">
          {CALENDAR_2026.map(c => (
            <div key={c.mo + c.city} className="grid grid-cols-[80px_140px_1fr_120px_auto] gap-4 lg:gap-8 px-5 lg:px-8 py-5 items-baseline">
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#7B1A1A]">{c.mo} 2026</p>
              <p className="font-serif italic text-xl">{c.city}</p>
              <p className="font-serif text-base text-[#1A1410]/85" dangerouslySetInnerHTML={{ __html: c.t }} />
              <span className={`font-mono text-[10px] tracking-[0.28em] uppercase ${c.state === 'open' ? 'text-[#1A6B3A]' : c.state === 'waitlist' ? 'text-[#7B1A1A]' : 'text-[#1A1410]/35'}`}>● {c.state}</span>
              <button disabled={c.state === 'closed'} onClick={() => setPage('apply')} className="font-mono text-[10px] tracking-[0.3em] uppercase border border-[#1A1410]/35 px-4 py-2 hover:bg-[#1A1410] hover:text-[#F4EEE0] disabled:opacity-30 disabled:cursor-not-allowed transition-colors" data-testid={`mv-cal-${c.mo}`}>{c.state === 'closed' ? 'Sold out' : 'Apply →'}</button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

function Row({ k, v, bold = false }) {
  return (
    <div className="flex items-baseline justify-between gap-4 border-b border-[#1A1410]/15 pb-2.5">
      <span className="text-[#1A1410]/45">{k}</span>
      <span className={bold ? 'text-[#7B1A1A] font-serif normal-case tracking-normal text-base' : 'text-[#1A1410] font-serif normal-case tracking-normal'} dangerouslySetInnerHTML={{ __html: v }} />
    </div>
  );
}
